import moment from "moment";

import eventAction from "@/store/eventAction";
import cache from "@/store/cache.js";

function defaultState() {
  return {
    all: []
  };
}
// state
const state = defaultState();

// getters
const getters = {};

// actions
const actions = {
  clear({ state }) {
    Object.assign(state, defaultState());
  },
  socket_cardMessages({ commit }, data) {
    if (data.card_messages) {
      commit(
        "ADD_RANGE",
        data.card_messages.map(message => {
          return {
            card: cache.cards.byId(message.card_id),
            message: message
          };
        })
      );
    }
  },

  new({ dispatch }, { card, text }) {
    dispatch(
      "events/emit",
      {
        action: eventAction.card.message.new,
        card: card,
        data: text
      },
      { root: true }
    );
  },

  handleEvent({ rootState, commit }, event) {
    const requirements = eventAction.requireFor(rootState, event);
    if (!requirements) return;

    switch (event.action) {
      case eventAction.card.message.new: {
        const newMessage = {
          id: event.param2,
          text: event.data,
          user_id: event.user_id,
          card_id: event.card_id,
          date: event.date
        };

        commit("ADD", {
          card: cache.cards.byId(event.card_id),
          message: newMessage
        });
        break;
      }
    }
  }
};

function add(state, card, message) {
  if (!message) return;

  if (!message.id) {
    console.error("Cant add card_message without id", message);
    return;
  }

  if (!card) {
    console.error("card is not existing for card_message", message);
    return;
  }

  if (!message.card_id) {
    message.card_id = card.id;
  }

  //message.isMy = message.user_id == state.user.id;
  message.moment = moment(message.date);
  if (!card.messages.find(m => m.id == message.id)) {
    card.messages.push(message);
    state.all.push(message);
  }
}

// mutations
const mutations = {
  ADD_RANGE(state, items) {
    items.forEach(i => {
      add(state, i.card, i.message);
    });
  },
  ADD(state, { card, message }) {
    add(state, card, message);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
